angular.module('logbook')
.directive('tagStyleEditor', ['$timeout', "$http", "$location", "$window", "tagService", 
function($timeout, $http, $location, $window, tagService) {
  return {
    restrict: 'E',

    scope: {
       styles: '=',
       updateStyles: '=',
       updateStylesRef: '=',
       editViewOnly: '=',
       id: '=',
       selectedLog: '=',
       editDisabled: '=?'
    },

	template: require('./tag-style-editor.html'),

    link: function(scope, elem, attrs) {
       scope.editing = scope.editViewOnly ? true : false;
       
       scope.updateSelectedStyles = function()
       {
          scope.selectedStyles = {};
          delete scope.textStyle;
          scope.styles && scope.styles.forEach(function(style) {
             console.log(scope.id + ": " + style);
             scope.tagStyles.forEach(function(tagStyle) {
                if( style._links.self.href.replace(/\{.*\}/,'') === tagStyle._links.self.href )
                {
                   if( tagStyle.styleGroup == 'TEXT' )
                      scope.textStyle = tagStyle;
                   else if( tagStyle.styleGroup == null )
                      scope.selectedStyles[tagStyle._links.self.href] = true;
                };
             });
          });
       };
       
       tagService.getTagStyles().subscribe(tagStyles => {
		  scope.tagStyles = tagStyles;
		  
          scope.updateSelectedStyles();
       });
       
       scope.startEditing = function()
       {
          scope.editing = true;
       };
       
       scope.stopEditing = function()
       {
          scope.editing = false;
       };
       
       scope.saveStyles = function()
       {
          scope.styles.length = 0;
          scope.styles = scope.getSelectedStyle(true, scope.styles);
          if( scope.updateStyles )
             scope.updateStyles(scope.updateStylesRef).then(function() {
                scope.editing = false;
             });
          else
             scope.editing = scope.editViewOnly ? true : false;
       };
       
       scope.$on('saveStyles', function(event, id) {
          if( scope.id === id)
             scope.saveStyles();
       });
       
       scope.$on('updateSelectedStyles', function(event,id) {
          if( scope.id === id)
             scope.updateSelectedStyles();
       });
       
       
       scope.getSelectedStyle = function(wantHref, result)
       {
          if( !result ) result = [];
          if( scope.textStyle )
             result.push(wantHref ? scope.textStyle._links.self.href : scope.textStyle.description);
          
          scope.selectedStyles &&
          Object.keys(scope.selectedStyles).forEach(function(style) {
             if( scope.selectedStyles[style] )
             {
                scope.tagStyles.forEach(function(tagStyle) {
                   if( tagStyle._links.self.href === style )
                      result.push(wantHref ? tagStyle._links.self.href : tagStyle.description);
                });
             }
                
          });
          return result;
       };
       
    }
  }
}]);
